import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'

import { GENERAL_LEDGER_HEADERS, NOT_APPLICABLE } from '../../../constants'
import { CustomPagination } from '../../common/CustomPagination'
import { CustomTableCell } from '../../common/CustomTableCell'
import { StickyTable } from '../../common/StickyTable'
import { TableSkeleton } from '../../skeletons/TableSkeleton'
import { format } from 'date-fns'
import { LedgerReportPayload } from '../../../../generated'

interface LedgerListingProps {
  loading: boolean
  reports: LedgerReportPayload['reports']
}
const LedgerListing = ({ loading, reports }: LedgerListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading || false} />} height="405px">
      <TableHead>
        <TableRow>
          {GENERAL_LEDGER_HEADERS.map((columnName, index) => (
            <TableCell key={index} align="left" sx={{ fontWeight: 'bold', bgcolor: 'grey.100' }}>
              {columnName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {loading ? (
        <TableSkeleton noOfRows={7} noOfCols={GENERAL_LEDGER_HEADERS.length} />
      ) : (
        <TableBody>
          {reports?.map(report => {
            const { accountCode, accountId, accountName, amount, date, description, type, matter, payable, bill } =
              report || {}
            const hasMatter = matter?.caseNumber ?? matter?.consultMatterNumber
            return (
              <TableRow>
                <CustomTableCell value={`(#${accountCode}) ${accountName}`} to={`/accounts/chartered/${accountId}`} />
                <CustomTableCell value={format(new Date(date), 'MM/dd/yyyy')} maxWidth="376px" />
                <CustomTableCell value={type} />
                <CustomTableCell value={`$${amount.toFixed(2)}`} />
                <CustomTableCell
                  value={hasMatter ? `#${hasMatter}` : '--'}
                  to={hasMatter ? `/matters/matter-detail/${matter?.id}` : undefined}
                />
                <CustomTableCell
                  value={bill?.id ? `INV-${bill.id}` : '--'}
                  to={bill?.id ? `/billing/bill-detail/${bill?.id}` : undefined}
                />{' '}
                <CustomTableCell
                  value={payable?.id ? `V-${payable.voucherNo}` : '--'}
                  to={payable?.id ? `/accounts/payable/${payable.voucherNo}` : undefined}
                />
                <CustomTableCell value={description || NOT_APPLICABLE} />
              </TableRow>
            )
          })}
        </TableBody>
      )}
    </StickyTable>
  )
}

export default LedgerListing
